// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"300":"2ae674de","372":"0ac4086a","856":"85aec994","864":"ae889d80"}[chunkId] + ".chunk.js";
};